import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { register } from 'swiper/element/bundle'
import { Pagination } from 'swiper/modules'
import classNames from 'classnames'
import ButtonLink from '~components/ui/ButtonLink'
import 'swiper/css'
import '~styles/components/swiper.scss'
register()

const Carousel = ({ items, className }) => {
  const carouselRef = useRef()

  const params = {
    slidesPerView: 1,
    loop: true,
    module: [Pagination],
    pagination: {
      clickable: true,
      el: '.swiper-pagination'
    }
  }

  useEffect(() => initSwiper())

  const getWordCount = (string) => {
    const words = string.split(' ')

    if (words && words.length) {
      return words.length
    }

    return 0
  }

  const initSwiper = () => {
    Object.assign(carouselRef.current, params)
    carouselRef.current.initialize()
  }

  return (
    <div className={classNames('relative', className)}>
      <swiper-container
        ref={carouselRef}
        init="false"
        class="swiper relative flex-grow"
      >
        {items && items.map((item, index) => (
          <swiper-slide className="swiper-slide" key={`carousel-${index}`}>
            <div className="flex flex-col w-full h-full bg-charcoal">
              <div className={classNames('my-auto w-full z-10 px-4 pt-10 md:px-8 xl:py-15 xl:px-20 lg:flex lg:items-end lg:justify-between', { 'pb-15': getWordCount(item.attributes.text) >= 9 }, { 'pb-13': getWordCount(item.attributes.text) < 9 })}>
                <span className="block mr-10 text-white text-md md:text-2xl lg:text-md xl:text-2xl">
                  {item.attributes.text}
                </span>

                <ButtonLink
                  href={item.attributes.link}
                  className="flex-shrink-0 mt-6 xl:mt-10 xxs:p-4 xl:px-6"
                  theme="tertiary"
                >
                  {item.attributes.button_text}
                </ButtonLink>
              </div>

              <img
                src={item.attributes.image.lg}
                className="absolute top-0 left-0 block object-cover w-full h-full opacity-75"
              />
            </div>
          </swiper-slide>
        ))}
      </swiper-container>

      <div className="absolute left-0 z-10 flex items-center w-full h-2 px-6 text-left swiper-pagination bottom-6 md:px-8 lg:px-10 xl:px-20" />
    </div>
  )
}

Carousel.propTypes = {
  items: PropTypes.array,
  className: PropTypes.string
}

export default Carousel
